export default "__VITE_ASSET__379b7865__"